import React from 'react'
import banner from '../images/riya-dubey-banner.webp';

export default function Banner() {
  return (
    <>
       <section className='rd-banner'>
            <img src={banner} height="700" width="1600" alt="Riya Dubey Escorts Agency Logo" title="Riya Dubey Escorts Agency Logo" />
        </section>
    </>
  )
}
